import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllAccounts, deleteAccount } from "./AccountService";

export default function AccountList(){
  const [accounts,setAccounts] = useState([]);
  const nav = useNavigate();

  useEffect(()=>{ load(); },[]);

  const load = async ()=>{
    const data = await getAllAccounts();
    setAccounts(data);
  };

  const handleDelete = async (id)=>{
    if(!window.confirm("Delete account?")) return;
    await deleteAccount(id);
    load();
  };

  return (
    <div>
      <button onClick={()=>nav("new")}>➕ Add Account</button>

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Balance</th>
            <th>Number</th>
            <th>Comment</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {accounts.map(a=>(
            <tr key={a.id}>
              <td>{a.accountName}</td>
              <td>{a.type}</td>
              <td>₹ {a.currentBalance}</td>
              <td>{a.accountNumber}</td>
              <td>{a.comment}</td>
              <td>{a.isActive ? "Yes":"No"}</td>
              <td>
                <button onClick={()=>nav(`edit/${a.id}`)}>✏️</button>
                <button onClick={()=>handleDelete(a.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
